'use strict';

import { isObject } from 'lodash';
import urlParse from 'url-parse';
import baseConfig from './base';
import { customConfig } from './custom-config';

const dockerConfig = isObject(window.dockerConfig) ? compileDockerConfig(window.dockerConfig) : {};

const config = {
  appEnv: 'dist',
};

const featureFlags = {
  withAdminPanel: false,
  withCsvFilePreviewLongCellImprovements: false,
  withDashboardsExportableToOtherProjects: false,
  withMarkdownWidgetsDashboard: false,
  withStringSeriesPreviewDownload: false,
  withFloatSeriesTextPreview: false,
  withImprovedImageScalingAlgorithm: false,
  withShortenedMetrics: true,
  withNewLegendPositioning: true,
  withMyRuns: true,
  withEmaSmoothing: true,
  withGaussianSmoothing: false,
  withChemicalFilesPreview: false,
  withInitiatives: false,
  withDoubleClickZoomOut: true,
  withNonFiniteValues: false,
  withUdfWidget: false,
  withReportDslEditor: true,
  withWidgetDslEditor: false,
  withImprovedTooltipEditing: false,
  withAssociatedRunsOption: false,
  withScreenshotLegend: true,
  withDashboardLock: false,
  withNewChartAllowed: true,
  withNewChart: true,
  withMetricAggregatesHidden: true,
  withPulseCheckSurvey: false,
  withTristateSelection: true,
  withRunColorLists: true,
  withVegaLiteWidgets: true,
};

export default Object.freeze(
  Object.assign(
    { releasedVersion: '', appVersion: '' },
    baseConfig,
    config,
    featureFlags,
    dockerConfig,
    customConfig(),
  ),
);

function compileDockerConfig(config) {
  // in case of relative logoutURL, always convert to absolute as on-prems have problems when hosting from IPs
  const logoutURL = config.logoutURL
    ? urlParse(config.logoutURL).toString()
    : window.location.origin;

  const allowAddingNewLicense = !!config.allowAddingNewLicense;

  return Object.assign({}, config, {
    neptuneApiWSPort: config.neptuneApiPort,
    logoutURL,
    allowAddingNewLicense,
  });
}
